import React, { useState } from "react";
import styles from "./ConsumptionTrackingSidePanel.module.css";
import QuotaConsumption from "./QuotaConsumptions";
import QuotaExtentionDialog from "./QuotaExtensionDialog";
import { SidePanel, SidePanelContent } from "../side-panels";
import { translate } from "../../providers";
import { icon, IconComponent } from "../icon-component";
import { isNonEmptyArray } from "../../utils";

const ConsumptionTrackingSidePanel = ({
	allowedIntervals,
	companyName,
	displayContactSupport = false,
	consumption,
	onExtendQuota,
	onClose,
	open,
}) => {
	const [selectedConsumption, setSelectedConsumption] = useState(null);
	const handleOpen = (cons) => {
		setSelectedConsumption(cons);
	};
	const handleClose = () => {
		setSelectedConsumption(null);
	};
	return (
		<>
			<SidePanel open={open} size={40} onClose={onClose}>
				<SidePanelContent
					className={styles.content}
					title={translate("common:company.quotas.consumption-side-panel.title", { companyName })}
					onClose={onClose}
				>
					<div className={styles.container}>
						<div className={styles.header}>
							<IconComponent icon={icon.faBuilding} />
							<span className={styles.title}>
								{translate("common:company.quotas.consumption-side-panel.sub-title")}
							</span>
						</div>
						{(displayContactSupport && (
							<div className={styles.contactBody}>
								<div className={styles.contactTitle}>
									{translate("common:company.quotas.consumption-side-panel.contact.title")}
								</div>
								<div className={styles.contactSubTitle}>
									{translate("common:company.quotas.consumption-side-panel.contact.sub-title")}
								</div>
								<a className={styles.contactRef} href="mailto:support@aitenders.com">
									{translate("common:company.quotas.consumption-side-panel.contact.button")}
								</a>
							</div>
						)) || (
							<div className={styles.body}>
								{isNonEmptyArray(consumption) &&
									allowedIntervals?.map((interval) => {
										const intervalConsumption = consumption?.find((q) => q.type === interval);
										if (intervalConsumption) {
											return (
												<QuotaConsumption
													key={interval}
													addTooltip={translate(
														`common:company.quotas.consumption-side-panel.${interval.toLowerCase()}.tooltip`
													)}
													consumption={intervalConsumption}
													title={translate(
														`common:company.quotas.consumption-side-panel.${interval.toLowerCase()}.title`
													)}
													onClick={handleOpen}
													onExtendQuota={onExtendQuota}
												/>
											);
										}
										return null;
									})}
							</div>
						)}
					</div>
				</SidePanelContent>
			</SidePanel>
			<QuotaExtentionDialog
				consumption={selectedConsumption}
				open={!!selectedConsumption}
				onClose={handleClose}
				onExtendQuota={onExtendQuota}
			/>
		</>
	);
};

export default ConsumptionTrackingSidePanel;
